<div fxLayout="row" fxLayoutAlign="center center">

    <mat-card fxFlex="50%" fxFlex.xs="100%">
        <mat-card-header>
            <mat-card-title>Generar Código de Registro</mat-card-title>
            <mat-card-subtitle>El último código generado siempre invalida al anterior</mat-card-subtitle>
        </mat-card-header>
        <mat-divider></mat-divider>
        <form #f="ngForm" (ngSubmit)="onSubmit(f)">
            <mat-card-content>
    
                    <mat-form-field appearance="outline" class="control" style="padding-top: 10px;">
                        <mat-label>Correo electrónico</mat-label>
                        <input type="email" matInput placeholder="Correo electrónico" ngModel #correo_electronico="ngModel"
                            [pattern]="PatternsRegex.onlyEmail" ngModel name="correo_electronico"
                            oninput="this.value = this.value.toLowerCase()" required autocomplete="off"
                            [maxlength]="Length_Database.DB_LENGTH_SMALL_MAX_50">
                        <mat-icon matSuffix>{{Icons.PEOPLE}}</mat-icon>
                        <mat-error
                            *ngIf="correo_electronico.hasError('required')">{{Msjs_Validations.MSJ_VAL_CAMPO_VACIO}}</mat-error>
                        <mat-error
                            *ngIf="correo_electronico.hasError('pattern')">{{Msjs_Validations.MSJ_VAL_SOLO_EMAIL}}</mat-error>
                        <mat-error
                            *ngIf="correo_electronico.hasError('maxlength')">{{Msjs_Validations.MSJ_VAL_DB_LENGTH_SMALL_MAX_50}}</mat-error>
                    </mat-form-field>
                
            </mat-card-content>
            <mat-card-actions>
                <div  fxLayout="row" fxLayoutAlign="space-between center">
                    <app-button  [attr_type]="'submit'" [width]="100"  text="Generar código" [attr_disabled]="(f.invalid)"></app-button>
                    <app-button  [attr_type]="'button'" fxHide.xs type="outline" [width]="100" text="Cancelar" color="gray" (click)="cancelarCodigo()"></app-button>
                    <app-button [attr_type]="'button'"  fxShow.xs fxHide type="outline" color="gray-b0" [icon_fig]="Icons.CANCEL" (click)="cancelarCodigo()"></app-button>
                </div>
            </mat-card-actions>
        </form>
    </mat-card>

</div>